import About from "@/components/feature/About";

export default function AboutPage() {
  return <About />;
}